
import { Vue, Component, Prop } from 'vue-property-decorator'

import CustomWrapper from '@/components/CustomWrapper.vue'

const config = {
  name: 'c-poi-mini-card-thumbnail',
  components: { CustomWrapper }
}

@Component(config)
export default class CPoiMiniCardThumbnail extends Vue {

  @Prop({ type: String, default: 'div' }) tag!: string
  @Prop({ type: Boolean, default: false }) rounded!: boolean
  @Prop({ type: Boolean, default: false }) shadow!: boolean

  get CSSClasses () {
    return {
      '--Rounded': this.rounded,
      '--Shadow': this.shadow
    }
  }

}
